
import { fetchRequest } from './';
import { DownCode, WorksheetId } from './domain';
import { worksheetMessage, WorksheetResult } from './worksheet-service';

const service = 'downcode';

export type DowncodeResult = WorksheetResult<DownCode>;
export type DowncodeListResult = WorksheetResult<DownCode[]>;

export const saveDowncodesRequest = fetchRequest<DownCode, DowncodeResult>({
  method: 'post',
  body: (args: DownCode) => worksheetMessage(args, 'savedowncode', service),
});

export const updateDowncodeRequest = fetchRequest({
  method: 'post',
  body: (args: DownCode) => worksheetMessage(args, 'updatedowncode', service),
});

export const getDowncodesRequest = fetchRequest({
  method: 'post',
  body: (args: WorksheetId) => worksheetMessage(args, 'getdowncodes', service),
  notFoundResult: () => ({ result: [] }),
});

interface DowncodeIds extends WorksheetId {
  downcodeId: string;
}
export type DowncodeIdsResult = WorksheetResult<any>;

export const deleteDowncodesRequest = fetchRequest({
  method: 'post',
  body: (args: DowncodeIds) =>
    worksheetMessage(args, 'deletedowncode', service),
});
